import { FlexiToggle } from "appworks/graphics/elements/flexi-toggle";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { ToggleControl } from "./toggle-control";

export class BackgroundMusicToggleControl extends ToggleControl {

    constructor(protected button: FlexiToggle) {
        super(button);

        const startingValue = !Services.get(SoundService).getMusicMuted();
        this.button.setValue(startingValue);
    }

    protected onChange(value: boolean): void {
        Services.get(SoundService).setMusicMute(!value);
    }
}
